import {IHttpService, IPromise} from "angular";
import {remoteRoutingModule} from "./remoteRoutingModule";
import {RemoteRoutingUrls} from "./remoteRoutingUrls";
import {ExceptionMessage} from "front-end-web-commons/app/index.d.ts";

export interface InstanceTypeByRemoteServicesConfigParams {
    readonly orchestratorUrl: string;
    instanceTypeUpdateData: InstanceTypeUpdateData[];
}

export interface InstanceTypeWithRemoteServicesConfigParams {
    readonly orchestratorUrl: string;
    instanceTypeUpdateData: InstanceTypeUpdateData;
}

export interface InstanceTypeUpdateData {
    readonly id: number;
    readonly type: string;
    mappedMachineType: string;
    maxIdleTime: number;
}

export interface ResourceData{
    name: string;
    creationDate: Date;
    lastUsage: Date;
    usageCount: number;
    status: string;
    permissionGroupSourceId: string;
}

export class RemoteRoutingService {
    constructor(
        private $http: IHttpService,
        private remoteRoutingUrls: RemoteRoutingUrls) {
    }

    getMappedMachineTypes(): IPromise<String[]> {
        return this.$http.get<String[]>(this.remoteRoutingUrls["orchestrator.get-mapped-machine-types"]).then(response => response.data);
    }

    getRemoteTypesConfigurations(): IPromise<InstanceTypeByRemoteServicesConfigParams[]> {
        return this.$http.get<InstanceTypeByRemoteServicesConfigParams[]>(this.remoteRoutingUrls["orchestrator.remote-type-configuration"]).then(response => response.data);
    }

    createRemoteTypesConfigurations(): IPromise<InstanceTypeByRemoteServicesConfigParams[]> {
        return this.$http.get<InstanceTypeByRemoteServicesConfigParams[]>(this.remoteRoutingUrls["orchestrator.create-remote-type-configuration"]).then(response => response.data);
    }

    updateRemoteTypeConfigurations(configurations: InstanceTypeByRemoteServicesConfigParams[]) {
        return this.$http.post<any[]>(this.remoteRoutingUrls["orchestrator.update-type-configuration"], configurations)
            .then(response => response.data)
    }

    testRoutingParallelism(instaceTypeWithUrl: InstanceTypeWithRemoteServicesConfigParams): IPromise<ExceptionMessage> {
        return this.$http.post<ExceptionMessage>(this.remoteRoutingUrls["orchestrator.test-routing-parallelism"], instaceTypeWithUrl).then(response => response.data);
    }

    getRoutingAvailability(): IPromise<ResourceData[]> {
        return this.$http.get<ResourceData[]>(this.remoteRoutingUrls["orchestrator.get-routing-availability"])
            .then(response => response.data);
    }
}

remoteRoutingModule.service("remoteRoutingService", RemoteRoutingService)